import React from 'react';
import styled from '@benzinga/themetron';
import { Table } from '@benzinga/table';
import CoveyAnalystMetricsColumnsDef from './ColumnsDef';

export interface CoveyAnalystTableProps {
  data?: CoveyAnalystPortfolio[];
  title: string;
}

export interface CoveyAnalystPortfolio {
  symbol: string;
  percent: number;
}

export const CoveyAnalystTable: React.FC<CoveyAnalystTableProps> = ({ data, title }) => {
  if (!data) return null;

  const portfolioData = data
    ? data?.map(item => {
        const percent = item.percent * 100;

        return {
          percent,
          symbol: item.symbol,
        };
      })
    : [];

  return (
    <Container className="covey-analyst-metrics-table-container w-full">
      <div className="text-white font-semibold p-2 bg-[#1f5fca]">{title}</div>
      <Table columnsDef={CoveyAnalystMetricsColumnsDef} height={340} rowData={portfolioData} />
    </Container>
  );
};

const Container = styled.div`
  &.covey-analyst-metrics-table-container {
    border: 2px solid ${({ theme }) => theme.colorPalette.blue800};

    .benzinga-core-table {
      min-width: 300px;
      margin-bottom: unset;
    }
  }
`;
